import { ImgKey } from '../media/img-key'
import { OssConfig } from '../../config'

export class Sku extends ImgKey {

  sku_id: number
  barcode: string
  brand: string
  category: string
  name: string
  description: string
  img_key: string
  count: number

  _checked: boolean

  constructor(data: any = {}) {
    super(OssConfig.sku, data.img_key)
    this.sku_id = data.id || data.sku_id
    this.barcode = data.barcode
    this.brand = data.brand
    this.category = data.category
    this.name = data.name
    this.description = data.description
    this.img_key = data.img_key
    this.count = data.count === null ? -1 : data.count
    this._checked = false
  }

  get link(): string {
    return `/import/skus/${this.sku_id}`
  }

  public update(data: any = {}) {
    Object.keys(data).forEach(k => {
      this[k] = data[k]
    })
  }

  public toggleCheck() {
    this._checked = !this._checked
  }

}



// WEBPACK FOOTER //
// ./src/app/models/item/sku.ts